module.exports = __webpack_public_path__ + "static/img/快來看看300.c783387a.png";